import React from 'react'
import PropTypes from 'prop-types'
import { NavLink as Link } from 'react-router-dom'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Drawer from '@material-ui/core/Drawer'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import List from '@material-ui/core/List'
import ListSubheader from '@material-ui/core/ListSubheader'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import IconButton from '@material-ui/core/IconButton'
import Hidden from '@material-ui/core/Hidden'
import MenuIcon from '@material-ui/icons/Menu'
import ScheduleIcon from '@material-ui/icons/Schedule'
import Y from '../y18n'
import * as localesActions from '../store/locales'
import * as accountActions from '../store/accounts'
import { userRoutes, adminRoutes, accountRoutes, publicMenuRoutes, superAdminRoutes } from '../routes'

const drawerWidth = 300

const styles = theme => ({
  appBar: {
    position: 'absolute',
    width: '100%',
    backgroundColor: '#fff'
  },
  logoContainer: {
    paddingLeft: '16px',
    paddingRight: '16px',
    marginTop: '30px',
    marginBottom: '30px',
    width: 'calc(100% - 32px)'
  },
  logo: {
    width: '100%'
  },
  navIconHide: {
    [theme.breakpoints.up('md')]: {
      display: 'none'
    }
  },
  drawerPaper: {
    width: drawerWidth,
    position: 'relative',
    minHeight: '100vh'
  },
  flexRow: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  active: {
    display: 'flex',
    color: `${theme.palette.primary.main} !important`,
    '& span, & svg': {
      color: `${theme.palette.primary.main} !important`,
      fontWeight: 'bold'
    }
  }
})

const mapStateToProps = state => ({
  locales: state.locales,
  accounts: state.accounts
})
const mapDispatchToProps = dispatch => ({
  localesActions: bindActionCreators(localesActions, dispatch),
  accountActions: bindActionCreators(accountActions, dispatch)
})

class Navigation extends React.Component {
  state = {
    mobileOpen: false,
    activePath: ''
  }

  handleDrawerToggle = () => {
    this.setState(state => ({ mobileOpen: !state.mobileOpen }))
  }

  logout = () => {
    this.props.accountActions.logout()
  }

  render () {
    const { classes, locales, accounts } = this.props

    const drawer = (
      <div style={{ width: '100%', paddingBottom:'46px'}}> {/* Padding slightly in order to be able to get the last button in the list on mobile devices*/}
        <div className={classes.logoContainer}>
          <Link to={'/'} onClick={() => (this.state.mobileOpen ? this.handleDrawerToggle() : '')}>
            <img src={locales.logo} alt='logo' className={classes.logo} />
          </Link>
        </div>
        {accounts.isAuthenticated
          ? <List
            component='nav'
            subheader={<ListSubheader disableSticky component='div'>{Y`Navigate`}</ListSubheader>}
            >
            {userRoutes.concat(publicMenuRoutes).map(
                route =>
                  (route.show
                    ? <ListItem
                      button
                      key={route.name}
                      component={Link}
                      to={route.path}
                      activeClassName={classes.active}
                      onClick={() => (this.state.mobileOpen ? this.handleDrawerToggle() : '')}
                      >
                      <ListItemIcon>{<route.iconComponent />}</ListItemIcon>
                      <ListItemText inset primary={Y`${route.name}`} />
                    </ListItem>
                    : '')
              )}
          </List>
          : ''}
        {(accounts.isAuthenticated && accounts.profile.role === 'Admin') || accounts.profile.role === 'SuperAdmin'
          ? <List
            component='nav'
            subheader={<ListSubheader disableSticky component='div'>{Y`Administration`}</ListSubheader>}
            >
            {adminRoutes.map(
                route =>
                  (route.show
                    ? <ListItem
                      button
                      key={route.name}
                      component={Link}
                      to={route.path}
                      activeClassName={classes.active}
                      onClick={() => (this.state.mobileOpen ? this.handleDrawerToggle() : '')}
                      >
                      <ListItemIcon>{<route.iconComponent />}</ListItemIcon>
                      <ListItemText inset primary={Y`${route.name}`} />
                    </ListItem>
                    : '')
              )}
            {/*
            <ListItem
              button
              key={'hangfire'}
              onClick={() => (this.state.mobileOpen ? this.handleDrawerToggle() : '')}
              >
              <a href='/api/hangfire' target='_blank' style={{ textDecoration: 'none' }}>
                <ListItemIcon style={{ display: 'inline-block' }}><ScheduleIcon /></ListItemIcon>
                <ListItemText
                  style={{ display: 'inline-block', position: 'absolute', bottom: '25%', top: '25%' }}
                  inset
                  primary={Y`Scheduled jobs`}
                  />
              </a>
            </ListItem>
            */}
          </List>
          : ''}
        {accounts.isAuthenticated && accounts.profile.role === 'SuperAdmin' ?
        <List
          component='nav'
          subheader={<ListSubheader disableSticky component='div'>{Y`Super Administration`}</ListSubheader>}
        >
        {superAdminRoutes.map(
          route => (
            route.show ? 
              <ListItem
                button
                key={route.name}
                component={Link}
                to={route.path}
                activeClassName={classes.active}
                onClick={() => (this.state.mobileOpen ? this.handleDrawerToggle() : '')}>
                <ListItemIcon>{<route.iconComponent />}</ListItemIcon>
                <ListItemText inset primary={Y`${route.name}`}/>
              </ListItem>
              : ''
          )
        )}
        <ListItem
              button
              key={'hangfire'}
              onClick={() => (this.state.mobileOpen ? this.handleDrawerToggle() : '')}
              >
              <a href='/api/hangfire' target='_blank' style={{ textDecoration: 'none' }}>
                <ListItemIcon style={{ display: 'inline-block' }}><ScheduleIcon /></ListItemIcon>
                <ListItemText
                  style={{ display: 'inline-block', position: 'absolute', bottom: '25%', top: '25%' }}
                  inset
                  primary={Y`Scheduled jobs`}
                  />
              </a>
            </ListItem>
        </List>
        : ''
        }
        {accounts.isAuthenticated
          ? <List
            component='nav'
            subheader={<ListSubheader disableSticky component='div'>{Y`Account settings`}</ListSubheader>}
            >
            {accountRoutes.map(
                route =>
                  (route.show
                    ? route.component !== null
                        ? <ListItem
                          button
                          key={route.name}
                          component={Link}
                          to={route.path}
                          activeClassName={classes.active}
                          onClick={() => (this.state.mobileOpen ? this.handleDrawerToggle() : '')}
                          >
                          <ListItemIcon>{<route.iconComponent />}</ListItemIcon>
                          <ListItemText inset primary={Y`${route.name}`} />
                        </ListItem>
                        : <ListItem button onClick={() => this.logout()} key={route.name}>
                          <ListItemIcon>
                            <route.iconComponent />
                          </ListItemIcon>
                          <ListItemText inset primary={Y`${route.name}`} />
                        </ListItem>
                    : '')
              )}
          </List>
          : ''}
      </div>
    )

    return (
      <div style={{ height: '100vh', display: 'flex'}}>
        <Hidden mdUp>
          <AppBar className={classes.appBar}>
            <Toolbar className={classes.flexRow}>
              <IconButton
                color='inherit'
                aria-label='open drawer'
                onClick={this.handleDrawerToggle}
                className={classes.navIconHide}
              >
                <MenuIcon />
              </IconButton>
              <div>
                <Link to={'/'}>
                  <img src={locales.logo} alt='logo' style={{ height: '34px' }} />
                </Link>
              </div>
            </Toolbar>
          </AppBar>
        </Hidden>
        <Hidden mdUp>
          <Drawer
            variant='temporary'
            open={this.state.mobileOpen}
            onClose={this.handleDrawerToggle}
            classes={{
              paper: classes.drawerPaper
            }}
            ModalProps={{
              keepMounted: true // Better open performance on mobile.
            }}
          >
            {drawer}
          </Drawer>
        </Hidden>
        <Hidden smDown>
          <Drawer
            variant='permanent'
            open
            classes={{
              paper: classes.drawerPaper,
              docked: classes.drawerPaper
            }}
          >
            {drawer}
          </Drawer>
        </Hidden>
      </div>
    )
  }
}

Navigation.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired
}

Navigation = connect(mapStateToProps, mapDispatchToProps)(Navigation)
export default withStyles(styles, { withTheme: true })(Navigation)



// WEBPACK FOOTER //
// ./src/common/navigation.js